import React from "react";
import Step from "../Step.js";
import Explanation from "./index-concept.js";

const IndexStep = () => {
  return (
    <Step
      explanation={<Explanation />}
      code={null}
    />
  );
};

export default IndexStep;



// WEBPACK FOOTER //
// ./src/steps/index/index-step.js